if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    let hasControllerChanged = false;

    const activateWaitingServiceWorker = (registration) => {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    };

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hasControllerChanged) {
        return;
      }

      hasControllerChanged = true;
      window.location.reload();
    });

    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        console.log('✅ Service Worker registrado:', registration);

        // If there is already a waiting worker, activate it immediately.
        activateWaitingServiceWorker(registration);

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;

          if (!newWorker) {
            return;
          }

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              activateWaitingServiceWorker(registration);
            }
          });
        });

        // Force a periodic SW update check while the app is open.
        window.setInterval(() => {
          registration.update();
        }, 60000);
      })
      .catch((error) => {
        console.error('❌ Error al registrar el Service Worker:', error);
      });
  });
}

if (typeof window !== 'undefined') {
  let startY = 0;
  let startX = 0;
  let startedNearTopEdge = false;
  let refreshPromptShown = false;
  const PULL_REFRESH_THRESHOLD = 8;
  const TOP_EDGE_THRESHOLD = 80;
  const REFRESH_CONFIRM_MESSAGE = 'Estas a punto de cerrar sesión, deseas continuar?';

  const confirmarRecarga = () => window.confirm(REFRESH_CONFIRM_MESSAGE);

  const getScrollableAncestor = (node) => {
    let current = node;

    while (current && current !== document.body && current !== document.documentElement) {
      if (current instanceof HTMLElement) {
        const style = window.getComputedStyle(current);
        const overflowY = style.overflowY;
        const canScrollY = (overflowY === 'auto' || overflowY === 'scroll') && current.scrollHeight > current.clientHeight;

        if (canScrollY) {
          return current;
        }
      }

      current = current.parentElement;
    }

    return null;
  };

  const onTouchStart = (event) => {
    if (event.touches && event.touches.length > 0) {
      startY = event.touches[0].clientY;
      startX = event.touches[0].clientX;
      startedNearTopEdge = startY <= TOP_EDGE_THRESHOLD;
    }
  };

  const onTouchMove = (event) => {
    if (!event.touches || event.touches.length === 0 || event.touches.length > 1) {
      return;
    }

    const currentY = event.touches[0].clientY;
    const currentX = event.touches[0].clientX;
    const deltaY = currentY - startY;
    const deltaX = Math.abs(currentX - startX);
    const pullingDown = deltaY > 0;

    // Only guard top-edge pull gestures; regular scroll/swipe gestures should pass through.
    if (!startedNearTopEdge || !pullingDown || deltaY < PULL_REFRESH_THRESHOLD) {
      return;
    }

    // Horizontal swipes should never be blocked by this handler.
    if (deltaX > Math.abs(deltaY)) {
      return;
    }

    const target = event.target instanceof Element ? event.target : null;
    const scrollableAncestor = target ? getScrollableAncestor(target) : null;

    // If an internal scrollable container can consume the gesture, allow native scrolling.
    if (scrollableAncestor && scrollableAncestor.scrollTop > 0) {
      return;
    }

    const atTop = window.scrollY <= 0
      && document.documentElement.scrollTop <= 0
      && document.body.scrollTop <= 0;

    if (atTop && pullingDown && event.cancelable) {
      event.preventDefault();

      if (!refreshPromptShown) {
        refreshPromptShown = true;
        const continuar = confirmarRecarga();
        if (continuar) {
          window.location.reload();
        }
      }
    }
  };

  const onTouchEnd = () => {
    refreshPromptShown = false;
  };

  const onKeyDown = (event) => {
    const isF5 = event.key === 'F5';
    const isReloadShortcut = (event.ctrlKey || event.metaKey) && (event.key === 'r' || event.key === 'R');

    if (!isF5 && !isReloadShortcut) {
      return;
    }

    event.preventDefault();
    const continuar = confirmarRecarga();
    if (continuar) {
      window.location.reload();
    }
  };

  window.addEventListener('touchstart', onTouchStart, { passive: true });
  window.addEventListener('touchmove', onTouchMove, { passive: false });
  window.addEventListener('touchend', onTouchEnd, { passive: true });
  window.addEventListener('keydown', onKeyDown);
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/index';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

